"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RequestMethod;

(function (RequestMethod) {
  RequestMethod["delete"] = "DELETE";
  RequestMethod["get"] = "GET";
  RequestMethod["post"] = "POST";
  RequestMethod["put"] = "PUT";
})(RequestMethod = exports.RequestMethod || (exports.RequestMethod = {}));